import * as Vue from "vue";
const __vite_import_meta_env__ = { "BASE_URL": "/", "DEV": false, "MODE": "production", "PROD": true, "SSR": false };
const isVue27 = /^2\.7\.*/.test(Vue.version);
const isVue3 = /^3\.*/.test(Vue.version);
const isInnerScene = import.meta && __vite_import_meta_env__ && false;
export {
  isInnerScene,
  isVue27,
  isVue3
};
